import { NgModule } from "@angular/core";
import { UiModule } from "../../ui/ui.module";
import { NgxModule } from "../../ngx/ngx.module";

@NgModule({
  imports: [UiModule, NgxModule],
  exports: [UiModule, NgxModule],
})
export class MfaCommonModule {}
